import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import { CSPRoutes } from '../../routes/CSPRoutes';
import store from '../../store/store';
import { BrandContext } from '../../contextProviders/brandContext';
import { LaunchDarklyProvider } from '../../contextProviders/ldProvider';
import { nonSSOAuthorizationParams, ssoAuthorizationParams } from '../../constants/auth0Params';
import { AUTHENTICATION_TYPES } from '../../constants/constants';
import { BrandMetaTags } from '../../cspConfigs/brandMetaTags';
import { MakeConfig } from '../../helpers/configHelper';
import './csp.scss';

export const BaseCSP = ({ env, brandConfig, showBrandSwitch }) => {
  const brandContext = useContext(BrandContext);
  const currentEnv = process.env.REACT_APP_ENV || 'local';
  const { appDomain, appClientId, defaultAudience, authenticationType } =
    brandContext.activeBrandContext.cspConfiguration.auth0Config[currentEnv];
  const { seo } = brandContext.activeBrandContext.cspConfiguration;

  const isSSOAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;
  const useRefreshToken = !isSSOAuthentication;
  const authorizationParams = isSSOAuthentication ? ssoAuthorizationParams : nonSSOAuthorizationParams;
  const { audience, scope, responseType, redirectUri, connection } = authorizationParams;
  const cspConfig = MakeConfig({
    config: brandConfig,
    brokerFriendlyName: brandConfig.theme?.brand?.title || 'PetSure'
  });
  const { title, description } = seo || cspConfig.public.meta.seo;
  if (!appDomain || !appClientId || !audience || !scope || !responseType || !authenticationType) {
    return (
      <div>
        <h1>Missing Auth0 configuration</h1>
        <p>Please ensure that the Auth0 variables are configured for this brand.</p>
      </div>
    );
  }
  return (
    <>
      <BrandMetaTags
        {...cspConfig.public.meta}
        seo={{
          title,
          description
        }}
      />
      <LaunchDarklyProvider>
        <Provider store={store}>
          <Auth0Provider
            domain={appDomain}
            clientId={appClientId}
            useRefreshTokens={useRefreshToken}
            authorizationParams={{
              audience,
              scope,
              response_type: responseType,
              connection,
              redirect_uri: redirectUri
            }}
            cacheLocation="memory"
          >
            <CSPRoutes {...{ env, brandConfig, showBrandSwitch }} />
          </Auth0Provider>
        </Provider>
      </LaunchDarklyProvider>
    </>
  );
};

BaseCSP.propTypes = {
  env: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  brandConfig: PropTypes.any,
  showBrandSwitch: PropTypes.bool
};
